import { useOutletContext } from "react-router-dom";
import type { SubjectWithChildren } from "../../types.js";

export interface SubjectOutletContext {
  subject: SubjectWithChildren;
}

export function useSubjectContext(): SubjectOutletContext {
  return useOutletContext<SubjectOutletContext>();
}
